addEventListener('message', ({ data }) => {
    const { type, index, dataList, selectedParameters } = data;
    if (type === 'SUNBURST') {
        const tree = getSunBurstChildrenData(index, dataList, selectedParameters, []);
        postMessage(tree);
    } else if (type === 'SANKEY') {
        const sankey = getSankeyData(index, dataList, selectedParameters, { nodes: [], links: [], groups: [] });
        postMessage(sankey);
    }
});

const groupBy = (array, keyFn) => {
    return array.reduce((result, item) => {
        const key = typeof keyFn === 'function' ? keyFn(item) : item[keyFn];
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
        return result;
    }, {});
}

const uniq = (array) => {
    return Array.from(new Set(array));
}

const getGroupParam = (value) => {
    switch (value) {
        case 'Symptoms Category':
            return 'Beschwerdebild';
        case 'Treated symptoms':
            return 'Behandelte Symptome';
        case 'Indication':
            return 'Indikation';
        case 'Cannabis medicines':
            return 'Cannabisarzneimittel';
        case 'Age':
            return 'Alter';
        case 'Gender':
            return 'Geschlecht';
        case 'CAM therapy form':
            return 'CAM Therapieform';
        default:
            return value;
    }
}

export const getSunBurstChildrenData = (index: number, data: any[], selectedParameters: any[], childrenData: any[]) => {
    var parameter = selectedParameters[index];
    let groupParma = getGroupParam(parameter);
    if (groupParma) {
        switch (groupParma) {
            case "Behandelte Symptome":
                {
                    var allSymptoms: any[] = [];
                    data.forEach(item => {
                        if (Array.isArray(item.Symptoms)) {
                            item.Symptoms.forEach(symptom => {
                                if (symptom.label) {
                                    let findIndex = allSymptoms.findIndex(a => a.label == symptom.label);
                                    if (findIndex >= 0) {
                                        allSymptoms[findIndex].count += 1;
                                    } else {
                                        allSymptoms.push({ label: symptom.label, count: 1 });
                                    }
                                }
                            })
                        }
                    })

                    allSymptoms.forEach(symptom => {
                        var obj = {
                            "name": symptom.label,
                            "size": symptom.count,
                            "children": []
                        };
                        let nextIndex = index + 1;
                        if (nextIndex < selectedParameters.length) {
                            let newData = data.filter(a => a.Symptoms.findIndex(b => b.label == symptom.label) >= 0);
                            obj.children = getSunBurstChildrenData(nextIndex, newData, selectedParameters, obj.children)
                        }
                        childrenData.push(obj);
                    })
                }
                break;
            case "Cannabisarzneimittel":
                {
                    var allCannibs: any[] = [];
                    data.forEach(item => {
                        if (Array.isArray(item.Cannabisarzneimittel)) {
                            item.Cannabisarzneimittel.forEach(cannib => {
                                if (cannib.category.value) {
                                    let findIndex = allCannibs.findIndex(a => a.label == cannib.category.value);
                                    if (findIndex >= 0) {
                                        allCannibs[findIndex].count += 1;
                                    } else {
                                        allCannibs.push({ label: cannib.category.value, count: 1 });
                                    }
                                }
                            })
                        }
                    })

                    allCannibs.forEach(cannib => {
                        var obj = {
                            "name": cannib.label,
                            "size": cannib.count,
                            "children": []
                        };
                        let nextIndex = index + 1;
                        if (nextIndex < selectedParameters.length) {
                            let newData = data.filter(a => Array.isArray(a.Cannabisarzneimittel) && a.Cannabisarzneimittel.findIndex(b => b.category.value == cannib.label) >= 0);
                            obj.children = getSunBurstChildrenData(nextIndex, newData, selectedParameters, obj.children)
                        }
                        childrenData.push(obj);
                    })
                }
                break;
            case "CAM Therapieform":
                {
                    var allTherapies: any[] = [];
                    data.forEach(item => {
                        if (Array.isArray(item.CAMTherapie)) {
                            item.CAMTherapie.forEach(therapie => {
                                if (therapie) {
                                    let findIndex = allTherapies.findIndex(a => a.label == therapie);
                                    if (findIndex >= 0) {
                                        allTherapies[findIndex].count += 1;
                                    } else {
                                        allTherapies.push({ label: therapie, count: 1 });
                                    }
                                }
                            })
                        }
                    })

                    allTherapies.forEach(therapie => {
                        var obj = {
                            "name": therapie.label,
                            "size": therapie.count,
                            "children": []
                        };
                        let nextIndex = index + 1;
                        if (nextIndex < selectedParameters.length) {
                            let newData = data.filter(a => a.CAMTherapie.findIndex(b => b == therapie.label) >= 0);
                            obj.children = getSunBurstChildrenData(nextIndex, newData, selectedParameters, obj.children)
                        }
                        childrenData.push(obj);
                    })
                }
                break;
            default:
                {
                    let groupedData = groupBy(data, groupParma);
                    for (var key in groupedData) {
                        if (key && groupedData.hasOwnProperty(key)) {
                            var obj = {
                                "name": key,
                                "size": groupedData[key].length,
                                "children": []
                            };
                            let nextIndex = index + 1;
                            if (nextIndex < selectedParameters.length) {
                                let newData = data.filter(a => a[groupParma] == key);
                                obj.children = getSunBurstChildrenData(nextIndex, newData, selectedParameters, obj.children)
                            }
                            childrenData.push(obj);
                        }
                    }

                }
        }
    }
    return childrenData;
}

export const getSankeyData = (index: number, data: any[], selectedParameters: any[], response: any, objItem: any = null) => {
    var parameter = selectedParameters[index];
    let groupParma = getGroupParam(parameter);
    if (groupParma) {
        switch (groupParma) {
            case "Behandelte Symptome":
                {
                    var allSymptoms: any[] = [];
                    data.forEach(item => {
                        if (Array.isArray(item.Symptoms)) {
                            item.Symptoms.forEach(symptom => {
                                if (symptom.label) {
                                    let findIndex = allSymptoms.findIndex(a => a.label == symptom.label);
                                    if (findIndex >= 0) {
                                        allSymptoms[findIndex].count += 1;
                                    } else {
                                        allSymptoms.push({ label: symptom.label, count: 1 });
                                    }
                                }
                            })
                        }
                    })

                    let nodes = [];
                    allSymptoms.forEach(symptom => {
                        var nodeId = `${parameter}^${symptom.label}`;
                        var obj = {
                            "source": objItem ? objItem.target : nodeId,
                            "target": nodeId,
                            "value": symptom.count,
                            "type": parameter
                        };
                        let linkIndex = response.links.findIndex(a => a.source == obj.source && a.target == obj.target && a.type == obj.type);
                        if (linkIndex < 0) {
                            response.links.push(obj);
                        } else {
                            response.links[linkIndex]["value"] += symptom.count;
                        }
                        if (response.nodes.findIndex(a => a.id == nodeId) < 0) {
                            response.nodes.push({ id: nodeId, title: symptom.label });
                        }
                        if (nodes.findIndex(a => a == nodeId) < 0) {
                            nodes.push(nodeId);
                        }
                        let nextIndex = index + 1;
                        if (nextIndex < selectedParameters.length) {
                            let newData = data.filter(a => a.Symptoms.findIndex(b => b.label == symptom.label) >= 0);
                            getSankeyData(nextIndex, newData, selectedParameters, response, obj)
                        }
                    })
                    let groupIndex = response.groups.findIndex(a => a.id == parameter);
                    if (groupIndex < 0) {
                        response.groups.push({ id: parameter, title: parameter, nodes });
                    } else {
                        let gNodes = response.groups[groupIndex].nodes;
                        response.groups[groupIndex].nodes = uniq([...gNodes, ...nodes]);
                    }
                }
                break;
            case "Cannabisarzneimittel":
                {
                    var allCannibs: any[] = [];
                    data.forEach(item => {
                        if (Array.isArray(item.Cannabisarzneimittel)) {
                            item.Cannabisarzneimittel.forEach(cannib => {
                                if (cannib.category.value) {
                                    let findIndex = allCannibs.findIndex(a => a.label == cannib.category.value);
                                    if (findIndex >= 0) {
                                        allCannibs[findIndex].count += 1;
                                    } else {
                                        allCannibs.push({ label: cannib.category.value, count: 1 });
                                    }
                                }
                            })
                        }
                    })

                    let nodes = [];
                    allCannibs.forEach(cannib => {
                        var nodeId = `${parameter}^${cannib.label}`;
                        var obj = {
                            "source": objItem ? objItem.target : nodeId,
                            "target": nodeId,
                            "value": cannib.count,
                            "type": parameter
                        };
                        let linkIndex = response.links.findIndex(a => a.source == obj.source && a.target == obj.target && a.type == obj.type);
                        if (linkIndex < 0) {
                            response.links.push(obj);
                        } else {
                            response.links[linkIndex]["value"] += cannib.count;
                        }
                        if (response.nodes.findIndex(a => a.id == nodeId) < 0) {
                            response.nodes.push({ id: nodeId, title: cannib.label });
                        }
                        if (nodes.findIndex(a => a == nodeId) < 0) {
                            nodes.push(nodeId);
                        }
                        let nextIndex = index + 1;
                        if (nextIndex < selectedParameters.length) {
                            let newData = data.filter(a => Array.isArray(a.Cannabisarzneimittel) && a.Cannabisarzneimittel.findIndex(b => b.category.value == cannib.label) >= 0);
                            getSankeyData(nextIndex, newData, selectedParameters, response, obj)
                        }
                    })
                    let groupIndex = response.groups.findIndex(a => a.id == parameter);
                    if (groupIndex < 0) {
                        response.groups.push({ id: parameter, title: parameter, nodes });
                    } else {
                        let gNodes = response.groups[groupIndex].nodes;
                        response.groups[groupIndex].nodes = uniq([...gNodes, ...nodes]);
                    }
                }
                break;
            case "CAM Therapieform":
                {

                    var allTherapies: any[] = [];
                    data.forEach(item => {
                        if (Array.isArray(item.CAMTherapie)) {
                            item.CAMTherapie.forEach(therapie => {
                                if (therapie) {
                                    let findIndex = allTherapies.findIndex(a => a.label == therapie);
                                    if (findIndex >= 0) {
                                        allTherapies[findIndex].count += 1;
                                    } else {
                                        allTherapies.push({ label: therapie, count: 1 });
                                    }
                                }
                            })
                        }
                    })

                    let nodes = [];
                    allTherapies.forEach(therapie => {
                        var nodeId = `${parameter}^${therapie.label}`;
                        var obj = {
                            "source": objItem ? objItem.target : nodeId,
                            "target": nodeId,
                            "value": therapie.count,
                            "type": parameter
                        };
                        let linkIndex = response.links.findIndex(a => a.source == obj.source && a.target == obj.target && a.type == obj.type);
                        if (linkIndex < 0) {
                            response.links.push(obj);
                        } else {
                            response.links[linkIndex]["value"] += therapie.count;
                        }
                        if (response.nodes.findIndex(a => a.id == nodeId) < 0) {
                            response.nodes.push({ id: nodeId, title: therapie.label });
                        }
                        if (nodes.findIndex(a => a == nodeId) < 0) {
                            nodes.push(nodeId);
                        }
                        let nextIndex = index + 1;
                        if (nextIndex < selectedParameters.length) {
                            let newData = data.filter(a => a.CAMTherapie.findIndex(b => b == therapie.label) >= 0);
                            getSankeyData(nextIndex, newData, selectedParameters, response, obj)
                        }
                    })
                    let groupIndex = response.groups.findIndex(a => a.id == parameter);
                    if (groupIndex < 0) {
                        response.groups.push({ id: parameter, title: parameter, nodes });
                    } else {
                        let gNodes = response.groups[groupIndex].nodes;
                        response.groups[groupIndex].nodes = uniq([...gNodes, ...nodes]);
                    }
                }
                break;
            default:
                {
                    let groupedData = groupBy(data, groupParma);
                    let nodes = [];
                    for (var key in groupedData) {
                        if (key && groupedData.hasOwnProperty(key)) {
                            var nodeId = `${parameter}^${key}`;
                            var obj = {
                                "source": objItem ? objItem.target : nodeId,
                                "target": nodeId,
                                "value": groupedData[key].length,
                                "type": parameter
                            };
                            let linkIndex = response.links.findIndex(a => a.source == obj.source && a.target == obj.target && a.type == obj.type);
                            if (linkIndex < 0) {
                                response.links.push(obj);
                            } else {
                                response.links[linkIndex]["value"] += groupedData[key].length;
                            }
                            if (response.nodes.findIndex(a => a.id == nodeId) < 0) {
                                response.nodes.push({ id: nodeId, title: key });
                            }
                            if (nodes.findIndex(a => a == nodeId) < 0) {
                                nodes.push(nodeId);
                            }
                            let nextIndex = index + 1;
                            if (nextIndex < selectedParameters.length) {
                                let newData = data.filter(a => a[groupParma] == key);
                                getSankeyData(nextIndex, newData, selectedParameters, response, obj)
                            }
                        }
                    }
                    let groupIndex = response.groups.findIndex(a => a.id == parameter);
                    if (groupIndex < 0) {
                        response.groups.push({ id: parameter, title: parameter, nodes });
                    } else {
                        let gNodes = response.groups[groupIndex].nodes;
                        response.groups[groupIndex].nodes = uniq([...gNodes, ...nodes]);
                    }

                }
        }
    }
    return response;
}
